import { literal, number, object, preprocess } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { ProductGroupsSchema } from '@occc/validation';

import { BasePromotionSchema } from './base-promotion.schema';

import { PromotionType } from '../types';

export const BuyAndGetEarningMechanismSchema = object({
  purchaseThreshold: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  discountThreshold: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  eligibleProductGroups: ProductGroupsSchema,
});

export const BuyAndGetFormSchema = BasePromotionSchema.extend({
  offerType: literal(PromotionType.BuyAndGet),
  buyAndGet: preprocess((val) => val ?? {}, BuyAndGetEarningMechanismSchema),
});
